import DefaultLayout from 'src/pages/layouts/DefaultLayout.vue'
import AuthLayout from 'src/pages/layouts/AuthLayout.vue'
import Header from 'src/pages/headers/Header.vue'
import Home from 'src/pages/carenation/doctor/DoctorHome.vue'
import MyAvailability from 'src/pages/carenation/doctor/MyAvailability.vue'
import Credits from 'src/pages/carenation/nurse/Credits.vue'
import CreditEarnings from 'src/pages/carenation/nurse/CreditEarnings.vue'
import Dashboard from 'src/pages/carenation/Dashboard.vue'
import DoctorDashboard from 'src/pages/carenation/DoctorDashboard.vue'

import GetHelpNow from 'src/pages/carenation/GetHelpNow.vue'

import Message from 'src/pages/carenation/Message.vue'
import Telemed from 'src/pages/carenation/Telemed.vue'
import TelemedDiscussion from 'src/pages/carenation/TelemedDiscussion.vue'
import ViewAppointment from 'src/pages/carenation/ViewAppointment.vue'
import Profile from 'src/pages/carenation/Profile.vue'
import ChangePasssword from 'src/pages/carenation/ChangePassword.vue'
import ShouldChangePassword from 'src/pages/carenation/ShouldChangePassword.vue'
import ViewAppointmentDetails from 'src/pages/carenation/doctor/ViewAppointmentDetails.vue'
import TermsOfUse from 'src/pages/carenation/TermsOfUse.vue'
import PrivacyPolicy from 'src/pages/carenation/PrivacyPolicy.vue'
import HelpVideos from 'src/pages/carenation/HelpVideos.vue'
import Support from 'src/pages/carenation/Support.vue'
import Feedback from 'src/pages/carenation/Feedback.vue'
import RecordingViewer from 'src/pages/carenation/doctor/RecordingViewer.vue'
import PatientHistory from "../pages/carenation/careco/PatientHistory.vue"

// issue tracker
import IssueTracker from '../pages/carenation/issues/IssueTracker.vue';
import CreateIssue from '../pages/carenation/issues/CreateIssue.vue';
import ViewIssue from '../pages/carenation/issues/ViewIssue.vue';

//Nurse views
import NurseHome from 'src/pages/carenation/nurse/NurseHome.vue'
import CreatePatient from 'src/pages/carenation/nurse/CreatePatient.vue'
import EditPatient from 'src/pages/carenation/nurse/EditPatient.vue'
import ViewPatient from 'src/pages/carenation/nurse/ViewPatient.vue'
import Vitals from 'src/pages/carenation/nurse/Vitals.vue'
import ScanVital from 'src/pages/carenation/nurse/ScanVital.vue'
import Questionnaires from 'src/pages/carenation/nurse/Questionnaires.vue'
import AnswerQuestionnaires from 'src/pages/carenation/nurse/AnswerQuestionnaires.vue'
import AnsweredQuestionnaire from 'src/pages/carenation/nurse/AnsweredQuestionnaire.vue'
import FilesHistory from 'src/pages/carenation/nurse/FilesHistory.vue'
import NotesHistory from 'src/pages/carenation/nurse/NotesHistory.vue'
import CreateAppointment from 'src/pages/carenation/nurse/CreateAppointment.vue'
import CreateQuickDiscussionAppointment from 'src/pages/carenation/nurse/CreateQuickDiscussionAppointment.vue'
import CreateLabOrder from 'src/pages/carenation/nurse/CreateLabOrder.vue'
import ViewLabOrderDetails from 'src/pages/carenation/nurse/ViewLabOrderDetails.vue'
import CreateEmergencyTriaging from 'src/pages/carenation/nurse/CreateEmergencyTriaging.vue'
import ConsentManagement from 'src/pages/carenation/nurse/ConsentManagement.vue'

//Nurse views
import CareCoordinatorHome from 'src/pages/carenation/careco/Home.vue'
import AttendRequest from 'src/pages/carenation/careco/AttendRequest.vue'

//Patient views
import PatientHome from 'src/pages/carenation/patient/PatientHome.vue'
import Reminders from 'src/pages/carenation/patient/Reminders.vue'
import PrescriptionForReminders from 'src/pages/carenation/patient/PrescriptionForReminders.vue'
import SelectedPrescriptionForReminders from 'src/pages/carenation/patient/SelectedPrescriptionForReminders.vue'
import SetReminders from 'src/pages/carenation/patient/SetReminders.vue'
import BatteryOptimization from 'src/pages/carenation/patient/BatteryOptimization.vue'
import ManageMyDoctors from 'src/pages/carenation/patient/ManageMyDoctors.vue'
import Videos from 'src/pages/carenation/patient/Videos.vue'
import FitnessVideos from 'src/pages/carenation/patient/FitnessVideos.vue'
import FitnessSchedule from 'src/pages/carenation/patient/FitnessSchedule.vue'
import YogaSchedule from 'src/pages/carenation/patient/YogaSchedule.vue'
import FitnessSets from 'src/pages/carenation/patient/FitnessSets.vue'
import YogaSets from 'src/pages/carenation/patient/YogaSets.vue'
import OrderMedicines from 'src/pages/carenation/patient/OrderMedicines.vue'
import Training from 'src/pages/carenation/patient/Training.vue'
import Exercise from 'src/pages/carenation/patient/Exercise.vue'
import NutritionHome from 'src/pages/carenation/patient/NutritionHome.vue'
import Recipe from 'src/pages/carenation/patient/Recipe.vue'
import ViewAllRecipes from 'src/pages/carenation/patient/ViewAllRecipes.vue'
import NutritionVideos from 'src/pages/carenation/patient/NutritionVideos.vue'
import YogaVideos from 'src/pages/carenation/patient/YogaVideos.vue'
import BlogArticle from 'src/pages/carenation/patient/BlogArticle.vue'
import BlogFeed from 'src/pages/carenation/patient/BlogFeed.vue'
import Forum from 'src/pages/carenation/components/forum/Forum.vue'
import ViewForumPost from 'src/pages/carenation/patient/ViewForumPost.vue'
import AHC from 'src/pages/carenation/patient/Ahc.vue'
import RequestAhc from 'src/pages/carenation/patient/RequestAhc.vue'
import CreateAdhocAppointment from 'src/pages/carenation/patient/CreateAdhocAppointment'
import Bookings from 'src/pages/carenation/Bookings'
import RequestedAhc from 'src/pages/carenation/patient/RequestedAhc.vue'
import AhcReport from 'src/pages/carenation/patient/AhcReport.vue'
import viewHealthCheckupRequest from 'src/pages/carenation/patient/viewHealthCheckupRequest.vue'
import viewSchedueledHealthCheckupRequest from 'src/pages/carenation/patient/viewScheduledHealthCheckupRequest.vue'
import Slots from 'src/pages/carenation/Slots.vue'
import Speciality from 'src/pages/carenation/Speciality.vue'
import ConfirmBooking from 'src/pages/carenation/ConfirmBooking.vue'
import Waiting from 'src/pages/carenation/Waiting.vue'
import PatientVitals from 'src/pages/carenation/patient/PatientVitals.vue'
import ShowPatientVitals from 'src/pages/carenation/patient/ShowPatientVitals.vue'
import VitalsHelp from 'src/pages/carenation/patient/VitalsHelp.vue'
import AddVital from 'src/pages/carenation/patient/AddVital.vue'
import MyHealth from 'src/pages/carenation/patient/MyHealth.vue'
import BookLabTest from 'src/pages/carenation/patient/BookLabTest.vue'
import ViewPatientLabOrders from 'src/pages/carenation/patient/ListPatientLabOrders.vue'
import TrainerConsult from 'src/pages/carenation/patient/TrainerConsult.vue'
import FitnessAndYogaReports from 'src/pages/carenation/patient/FitnessAndYogaReports.vue'
import ViewFitnessAndYogaReports from 'src/pages/carenation/patient/ViewFitnessAndYogaReports.vue'
import Wellness from 'src/pages/carenation/patient/Wellness.vue'
import Checkin from 'src/pages/carenation/patient/Checkin.vue'

// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'

import IcuVisit from "../pages/carenation/doctor/IcuVisit.vue"

import IcuBed from "../pages/carenation/IcuBed.vue"
import IcuWard from "../pages/carenation/IcuWard.vue"

// Pages
import Login from 'src/pages/Signin.vue'
import BaseUrl from 'src/pages/BaseUrl.vue'

import LabOperatorHome from '../pages/carenation/laboperator/LabOperatorHome.vue'
import LabRunnerHome from '../pages/carenation/labrunner/LabRunnerHome.vue'

import AmbulanceDriverHome from '../pages/carenation/ambulancedriver/AmbulanceDriverHome'
import VehicleStats from '../pages/carenation/ambulancedriver/VehicleStats.vue'
import AmbulanceFeedback from '../pages/carenation/AmbulanceFeedback.vue'

import SigninTermsOfUse from '../pages/SigninTermsOfUse.vue'
import SigninPrivacyPolicy from '../pages/SigninPrivacyPolicy.vue'

import PostponedPrescription from "../pages/carenation/PostponedPrescription.vue"

import ViewHistoricPrescription from "../pages/carenation/ViewHistoricPrescription.vue"

import store from '@/store/store.js'

let authPages = {
  path: '/',
  component: AuthLayout,
  name: 'Authentication',
  children: [
    {
      path: '/signin',
      name: 'Login',
      component: Login
    },
    {
      path: '/baseurl',
      name: 'Base URL',
      component: BaseUrl
    }
  ]
}
const pageAuthorizations = {};
pageAuthorizations['/'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/home'] = ['doctor']
pageAuthorizations['/nursehome'] = ['nurse']
pageAuthorizations['/carecohome'] = ['careCoordinator']
pageAuthorizations['/laboperatorhome'] = ['lab-operator']
pageAuthorizations['/labrunnerhome'] = ['lab-runner']
pageAuthorizations['/patienthome'] = ['patient']
pageAuthorizations['/ambulancedriverhome'] = ['ambulance-driver']
pageAuthorizations['/myavailability'] = ['doctor']
pageAuthorizations['/credits'] = ['nurse']
pageAuthorizations['/earnings'] = ['nurse']
pageAuthorizations['/message'] = ['doctor', 'patient']
pageAuthorizations['/telemed'] = ['doctor', 'nurse', 'careCoordinator', 'patient']
pageAuthorizations['/telemeddiscussion'] = ['doctor', 'nurse']
pageAuthorizations['/postponedprescription'] = ['doctor', 'nurse', 'careCoordinator']
pageAuthorizations['/viewappointment'] = ['doctor', 'nurse', 'careCoordinator', 'patient']
pageAuthorizations['/profile'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/changepassword'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/shouldchangepassword'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/viewappointmentdetails'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/patienthistory'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/termsofuse'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/privacypolicy'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/helpvideos'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/support'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/issuetracker'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/createissue'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/feedback'] = ['doctor', 'nurse', 'careCoordinator', 'lab-operator', 'lab-runner', 'patient', 'ambulance-driver'];
pageAuthorizations['/ambulancefeedback'] = ['ambulance-driver'];
pageAuthorizations['/recordingviewer'] = ['doctor', 'nurse', 'careCoordinator'];
pageAuthorizations['/attendrequest'] = ['careCoordinator', 'patient'];
pageAuthorizations['/patients/create'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/scanvital'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/patient/files'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/patient/notes'] = ['doctor', 'nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/appointments/create'] = ['nurse', 'careCoordinator', 'patient'];
pageAuthorizations['/laborders/create'] = ['nurse', 'lab-operator', 'lab-runner'];
pageAuthorizations['/videos'] = ['patient'];
pageAuthorizations['/ahc'] = ['careCoordinator', 'patient'];
pageAuthorizations['/requestahc'] = ['patient'];
pageAuthorizations['/requestedahc'] = ['careCoordinator', 'patient'];
pageAuthorizations['/ahcreport'] = ['careCoordinator', 'patient'];
pageAuthorizations['/vehiclestats'] = ['ambulance-driver'];
pageAuthorizations['/icuvisit'] = ['doctor'];
pageAuthorizations['/confirmbooking'] = ['patient'];
pageAuthorizations['/waiting'] = ['patient'];
pageAuthorizations['/adhocappointment'] = ['patient']
pageAuthorizations['/dashboard'] = ['nurse']
pageAuthorizations['/doctordashboard'] = ['doctor']
pageAuthorizations['/scheduleappointment'] = ['patient']
pageAuthorizations['/appointments/quickdiscussion/create'] = ['nurse']
pageAuthorizations['/emergencyTriaging/create'] = ['nurse']
pageAuthorizations['/patientvitals'] = ['patient']
pageAuthorizations['/questionnaires'] = ['patient']
pageAuthorizations['/showpatientvitals'] = ['patient']
pageAuthorizations['/fitnessvideos'] = ['patient']
pageAuthorizations['/yogavideos'] = ['patient']
pageAuthorizations['/wellness'] = ['patient']
pageAuthorizations['/checkin'] = ['patient']
pageAuthorizations['/gethelpnow'] = ['patient']




const isAuthorized = (path) => {

  //Commented as it was not routing to prescription and files page
  // let routeInitial = '/' + path.split("/", 2)[1];
  if (localStorage.user && pageAuthorizations[path]) {
    let user = JSON.parse(localStorage.user);

    for (let role of pageAuthorizations[path]) {
      if (user.roles.includes(role)) {
        return true
      }
    }

    return false;

  } else {
    return false;
  }
}

const closeModals = () => {
  if (window.modals) {
    for (let modal of window.modals) {
      if (modal._props && modal._props.show && modal.closeModal) {
        modal._props.show = false;
        modal.closeModal()
      }
    }
  }
}

const routes = [
  {
    path: '/',
    beforeEnter(to, from, next) {
      closeModals();
      if (isAuthorized(to.path)) {
        next()
      } else {
        console.log(`User is not authorized for route ${to.path}`)
      }
    },
    redirect: function () {
      if (localStorage.user) {
        let user = JSON.parse(localStorage.user)

        if (user) {
          if (user.roles.includes('doctor')) {
            return '/home'
          } else if (user.roles.includes('nurse')) {
            return '/nursehome'
          }
          else if (user.roles.includes('careCoordinator')) {
            return '/carecohome'
          } else if (user.roles.includes('lab-operator')) {
            return '/laboperatorhome'
          } else if (user.roles.includes('lab-runner')) {
            return '/labrunnerhome'
          } else if (user.roles.includes('patient')) {
            return '/patienthome'
          } else if (user.roles.includes('ambulance-driver')) {
            return '/ambulancedriverhome'
          }
        }
        else if (localStorage.baseUrl) {
          return '/signin'
        }
        else {
          return '/baseurl'
        }
      }
      else if (localStorage.baseUrl) {
        return '/signin'
      }
      else {
        return '/baseurl'
      }
    }(),
    component: DefaultLayout,
    name: 'Dashboard',
    children: [{
      path: 'home',
      name: 'message.Home',
      components: { default: Home, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'gethelpnow',
      name: 'message.Get Help Now',
      components: { default: GetHelpNow, header: Header },
      meta: {
        BACK_BUTTON: false
      },

    },
    {
      path: 'wellness',
      name: 'message.routes74',
      components: { default: Wellness, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'myavailability',
      name: 'message.My Availability',
      components: { default: MyAvailability, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'credits',
      name: 'message.Credits',
      components: { default: Credits, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'earnings',
      name: 'message.Earnings',
      components: { default: CreditEarnings, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'dashboard',
      name: 'message.Dashboard',
      components: { default: Dashboard, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'doctordashboard',
      name: 'message.Dashboard',
      components: { default: DoctorDashboard, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'message',
      name: 'message.Message',
      components: { default: Message, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'telemed',
      name: 'message.Consultation',
      components: { default: Telemed, header: Header },
      meta: {
        BACK_BUTTON: false,
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'telemeddiscussion',
      name: 'message.Discussion',
      components: { default: TelemedDiscussion, header: Header },
      meta: {
        BACK_BUTTON: false,
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'postponedprescription',
      name: 'message.Consultation',
      components: { default: PostponedPrescription, header: Header },
      meta: {
        BACK_BUTTON: false,
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'viewhistoricprescription/:prescriptionId',
      name: 'message.Prescription',
      components: { default: ViewHistoricPrescription, header: Header },
      meta: {
        BACK_BUTTON: true,
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'viewappointment',
      name: 'message.View Appointment',
      components: { default: ViewAppointment, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'profile',
      name: 'message.Profile',
      components: { default: Profile, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'changepassword',
      name: 'message.Change Password',
      components: { default: ChangePasssword, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'shouldchangepassword',
      name: 'message.Change Password',
      components: { default: ShouldChangePassword, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'viewappointmentdetails',
      name: 'message.Appointment Details',
      components: { default: ViewAppointmentDetails, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'patienthistory',
      name: 'message.Patient History',
      components: { default: PatientHistory, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'termsofuse',
      name: 'message.Terms of Use',
      components: { default: TermsOfUse, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'privacypolicy',
      name: 'message.Privacy Policy',
      components: { default: PrivacyPolicy, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'helpvideos',
      name: 'message.Help & Support',
      components: { default: HelpVideos, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'support',
      name: 'message.Support',
      components: { default: Support, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'issuetracker',
      name: 'message.Issue tracker',
      components: { default: IssueTracker, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'createissue',
      name: 'New Issue ',
      components: { default: CreateIssue, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'viewissue/:issueId',
      name: 'message.Issue Details',
      components: { default: ViewIssue, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'feedback',
      name: 'message.Feedback',
      components: { default: Feedback, header: Header },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'ambulancefeedback',
      name: 'message.Feedback',
      components: { default: AmbulanceFeedback, header: Header },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'recordingviewer',
      name: 'message.View Recording',
      components: { default: RecordingViewer, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },

    //Nurse routes
    {
      path: 'nursehome',
      name: 'message.Nurse Home',
      components: { default: NurseHome, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },

    //Care Coordinator routes
    {
      path: 'carecohome',
      name: 'message.Home',
      components: { default: CareCoordinatorHome, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'attendrequest',
      name: 'message.Attend Request',
      components: { default: AttendRequest, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },

    //Nurse routes
    {
      path: 'patients/create',
      name: 'message.Create Patient',
      components: { default: CreatePatient, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'patients/edit/:patientId',
      name: 'message.Edit Patient',
      components: { default: EditPatient, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'myhealth',
      name: 'message.Edit Patient',
      components: { default: MyHealth, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'patients/view/:patientId',
      name: 'message.View Patient',
      components: { default: ViewPatient, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'vitals/:patientId',
      name: 'message.Vitals',
      components: { default: Vitals, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'checkin',
      name: 'message.Check-in',
      components: { default: Checkin, header: Header },
      meta: {
        BACK_BUTTON: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'patientvitals',
      name: 'message.routes52',
      path: 'patientvitals/:patientId',
      name: 'message.Devices',
      components: { default: PatientVitals, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'showpatientvitals',
      name: 'message.Vitals',
      components: { default: ShowPatientVitals, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'vitalshelp',
      name: 'message.help',
      components: { default: VitalsHelp, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'addvital',
      name: 'message.add vitals',
      components: { default: AddVital, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'scanvital',
      name: 'message.Scan Vital',
      components: { default: ScanVital, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'questionnaires/:patientId',
      name: 'message.Questionnaires',
      components: { default: Questionnaires, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'answerquestionnaires/:patientId',
      name: 'message.Answer Questrionnaires',
      components: { default: AnswerQuestionnaires, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'questionnaireanswers/:questionnaireAnswerId',
      name: 'message.Answered Questrionnaire',
      components: { default: AnsweredQuestionnaire, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
      , {
      path: '/patient/files',
      name: 'message.Files History',
      components: { default: FilesHistory, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: '/patient/notes',
      name: 'message.Notes History',
      components: { default: NotesHistory, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: '/appointments/create',
      name: 'message.Create New Appointment',
      components: { default: CreateAppointment, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: '/appointments/quickdiscussion/create',
      name: 'message.Create New Appointment',
      components: { default: CreateQuickDiscussionAppointment, header: Header },
      meta: {
        BACK_BUTTON: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: '/emergencyTriaging/create',
      name: 'message.Emergency Triaging',
      components: { default: CreateEmergencyTriaging, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'icubed/view/:bedId',
      name: 'icu bed',
      components: { default: IcuBed, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next()
      },
    },
    {
      path: 'icuward',
      name: 'icu ward',
      components: { default: IcuWard, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next()
      },
    },
    {
      path: '/consentmanagement',
      name: 'Consent management',
      components: { default: ConsentManagement, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'laboperatorhome',
      name: 'message.Home',
      components: { default: LabOperatorHome, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'labrunnerhome',
      name: 'message.Home',
      components: { default: LabRunnerHome, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: '/laborders/create',
      name: 'message.Create Lab Order',
      components: { default: CreateLabOrder, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: '/viewlaborderdetails/:orderId',
      name: 'message.Lab Order Details',
      components: { default: ViewLabOrderDetails, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    //Patient routes
    {
      path: 'patienthome',
      name: 'message.Patient Home',
      components: { default: PatientHome, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'reminders',
      name: 'message.reminders',
      components: { default: Reminders, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'prescriptionforreminders',
      name: 'message.select prescription',
      components: { default: PrescriptionForReminders, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'selectedprescriptionforreminders',
      name: 'message.Add reminders',
      components: { default: SelectedPrescriptionForReminders, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'selectedprescriptionforreminders',
      name: 'message.Add reminders',
      components: { default: SelectedPrescriptionForReminders, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'setreminders',
      name: 'message.set reminders',
      components: { default: SetReminders, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'batteryoptimization',
      name: 'message.Battery Optimization',
      components: { default: BatteryOptimization, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'managemydoctors',
      name: 'message.manage my doctors',
      components: { default: ManageMyDoctors, header: Header },
      meta: {
        BACK_BUTTON: true,
        SHOW_MENU: false
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'videos',
      name: 'message.Videos',
      components: { default: Videos, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'fitnessvideos',
      name: 'message.Fitness',
      components: { default: FitnessVideos, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'fitnessandyogareports',
      name: 'message.Reports',
      components: { default: FitnessAndYogaReports, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'viewfitnessandyogareports',
      name: 'message.View Report',
      components: { default: ViewFitnessAndYogaReports, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'yogasets',
      name: 'message.Yoga Sets',
      components: { default: YogaSets, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'fitnessschedule',
      name: 'message.Fitness Schedule',
      components: { default: FitnessSchedule, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'yogaschedule',
      name: 'message.Yoga Schedule',
      components: { default: YogaSchedule, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'fitnesssets',
      name: 'message.Workouts',
      components: { default: FitnessSets, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'ordermedicines',
      name: 'message.Order Medicines',
      components: { default: OrderMedicines, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'training',
      name: 'message.Training',
      components: { default: Training, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'exercise',
      name: 'message.Exercise',
      components: { default: Exercise, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (from && from.path && from.path == '/viewfitnessandyogareports') {
          if (store.state.trainingType == "yoga") {
            next("/yogaschedule")
          } else {
            next("/fitnessschedule")
          }
        } else {
          next()
        }
      },
    },
    {
      path: 'nutritionhome',
      name: 'message.Nutrition',
      components: { default: NutritionHome, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'recipe',
      name: 'message.Recipe',
      components: { default: Recipe, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'veiwallrecipes/:recipeType',
      name: 'message.View Recipes',
      components: { default: ViewAllRecipes, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'nutritionvideos',
      name: 'message.Nutrition Videos',
      components: { default: NutritionVideos, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'yogavideos',
      name: 'message.Yoga',
      components: { default: YogaVideos, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'blogarticle',
      name: 'message.Blog Article',
      components: { default: BlogArticle, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'blogfeed',
      name: 'message.Feed',
      components: { default: BlogFeed, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'forum',
      name: 'message.Forum',
      components: { default: Forum, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'viewforumpost/:postId',
      name: 'message.Forum post',
      components: { default: ViewForumPost, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'ahc',
      name: 'message.Requested Checkups',
      components: { default: AHC, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'requestahc',
      name: 'message.Request Health Checkup',
      components: { default: RequestAhc, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'adhocappointment',
      name: 'message.Consult a Doctor',
      components: { default: CreateAdhocAppointment, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'scheduleappointment',
      name: 'message.Schedule An Appointment',
      components: { default: Bookings, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'requestedahc',
      name: 'message.Requested Health Checkup',
      components: { default: RequestedAhc, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'ahcreport',
      name: 'message.Health Checkup Report',
      components: { default: AhcReport, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'booklabtest',
      name: 'message.Book lab test',
      components: { default: BookLabTest, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'viewpatientlaborders',
      name: 'message.Lab Orders',
      components: { default: ViewPatientLabOrders, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'trainerconsult',
      name: 'message.Trainer consultation',
      components: { default: TrainerConsult, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'slots/:doctorId',
      name: 'message.Select Slot',
      components: { default: Slots, header: Header },
      meta: { isBooking: true, BACK_BUTTON: true },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'speciality/:specialityId',
      name: 'message.speciality',
      components: { default: Speciality, header: Header },
      meta: { isBooking: true, BACK_BUTTON: true },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    }, {
      path: 'confirmbooking',
      name: 'message.Book Appointment',
      components: { default: ConfirmBooking, header: Header },
      meta: { isBooking: true, BACK_BUTTON: true },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'waiting',
      name: 'message.Appointment Details',
      components: { default: Waiting, header: Header },
      meta: { BACK_BUTTON: true },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    },
    {
      path: 'viewhealthcheckuprequest',
      name: 'message.View Health Checkup Request',
      components: { default: viewHealthCheckupRequest, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    {
      path: 'viewschedueledhealthcheckuprequest',
      name: 'message.View Schedueled Request',
      components: { default: viewSchedueledHealthCheckupRequest, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        next();
      },
    },
    //Ambulance routes
    {
      path: 'ambulancedriverhome',
      name: 'message.Ambulance Driver Home',
      components: { default: AmbulanceDriverHome, header: Header },
      meta: {
        BACK_BUTTON: false,
        SHOW_MENU: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }, {
      path: 'vehiclestats',
      name: 'message.Vehicle Statistics',
      components: { default: VehicleStats, header: Header },
      meta: {
        BACK_BUTTON: true
      },
      beforeEnter(to, from, next) {
        closeModals();
        if (isAuthorized(to.path)) {
          next()
        } else {
          console.log(`User is not authorized for route ${to.path}`)
        }
      },
    }
    ],
  },
  {
    path: '/icuvisit',
    name: 'message.Icu Visit',
    components: { default: IcuVisit },
    beforeEnter(to, from, next) {
      closeModals();
      if (isAuthorized(to.path)) {
        next()
      } else {
        console.log(`User is not authorized for route ${to.path}`)
      }
    },
  },
  {
    path: '/signintermsofuse',
    name: 'message.Terms of Use',
    components: { default: SigninTermsOfUse },
  }, {
    path: '/signinprivacypolicy',
    name: 'message.Privacy Policy',
    components: { default: SigninPrivacyPolicy },
  },
  authPages,

  //When route is not defined, go to signin
  { path: '*', component: Login }
];

export default routes
